import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "skeleton-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.max(_ctx.line, 1), (n) => {
      return (_openBlock(), _createElementBlock("div", {
        key: n,
        class: "skeleton-line",
        style: _normalizeStyle(_ctx.getStyle(n))
      }, null, 4))
    }), 128))
  ]))
}